import React from 'react';
import './Hero.css';


const Hero = () => {
    const scrollToProducts = () => {
        const productsSection = document.getElementById('products');
        if (productsSection) {
            productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const scrollToContact = () => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section id="home" className="hero">

            <div className="hero-content">
                <h1 className="hero-title animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                    Nurturing Nature, <span className="text-accent">Naturally</span>
                </h1>
                <p className="hero-subtitle animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
                    Naturally prepared compost and soil solutions, made with patience—not chemicals—for farmers, gardeners, and home growers
                </p>
                <p className="hero-tagline animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
                    Made in India | Farmer-led | Soil-first approach
                </p>
                <div className="hero-buttons animate-fade-in-up" style={{ animationDelay: '0.8s' }}>
                    <button className="btn btn-primary" onClick={scrollToProducts}>
                        Explore Products
                    </button>
                    <button className="btn btn-secondary" onClick={scrollToContact}>
                        Get in Touch
                    </button>
                </div>
                <div className="scroll-indicator">
                    <span>Scroll to explore</span>
                    <div className="scroll-arrow">▼</div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
